/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Refs_HInputs */

const en_wc_tut_refs_h = /** @type {(inputs: Wc_Tut_Refs_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Table of contents, footnotes and citations`)
};

/**
* | output |
* | --- |
* | "6. Table of contents, footnotes and citations" |
*
* @param {Wc_Tut_Refs_HInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_refs_h = /** @type {((inputs?: Wc_Tut_Refs_HInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Refs_HInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_refs_h(inputs)
});
export { wc_tut_refs_h as "wc.tut.refs.h" }